let mapsLoaderPromise = null;

export const loadGoogleMapsPlaces = (apiKey) => {
  if (typeof window !== "undefined" && window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google);
  }
  if (mapsLoaderPromise) return mapsLoaderPromise;
  mapsLoaderPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-google-maps="true"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.dataset.googleMaps = "true";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      apiKey || ""
    )}&libraries=places&v=weekly`;
    script.onload = () => resolve(window.google);
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return mapsLoaderPromise;
};


